import { createFileRoute } from '@tanstack/react-router';
import { QuizzesScreen } from '@/screens/quiz/QuizzesScreen';

export const Route = createFileRoute('/admin/quizzes/')({
  component: QuizzesScreen,
});
